var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('page-title',{attrs:{"title":_vm._f("t")(_vm.title)}}),_c('eagle-form',{attrs:{"form-key":_vm.formKey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }